import { enc, dec, toB64, fromB64 } from "./encoding";
import { randomBytes } from "./crypto";

export async function encryptWithDEK(dek: CryptoKey, text: string): Promise<{ iv: string; ciphertext: string }> {
  const iv = randomBytes(12);
  const data = enc.encode(text);
  const ct = await crypto.subtle.encrypt({ name: "AES-GCM", iv: iv as BufferSource }, dek, data);
  return { iv: toB64(iv), ciphertext: toB64(new Uint8Array(ct)) };
}

export async function decryptWithDEK(dek: CryptoKey, ciphertext: string, iv: string): Promise<string> {
  const pt = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: fromB64(iv) as BufferSource },
    dek,
    fromB64(ciphertext) as BufferSource
  );
  return dec.decode(pt);
}
